import React, { Component, Fragment } from "react";
import Navbar from "../partials/Navbar";
import Sidebar from "../partials/Sidebar";
import Footer from "../partials/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faList } from "@fortawesome/free-solid-svg-icons/faList";
import ReactDatatable from "@ashvin27/react-datatable";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { format } from "date-fns";
import axios from "axios";
import { addCommunityContest } from "../../actions/contestActions";
import { toast, Toaster } from "react-hot-toast";
import * as myConstList from "../../BaseUrl";
import classnames from "classnames";
import ReactGA from "react-ga";
import moment from "moment";
import $ from "jquery";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { Modal } from "react-bootstrap";

const jwtToken = localStorage.getItem("jwtToken");
const configToken = {
  headers: {
    Authorization: "Bearer " + `${localStorage.getItem("jwtToken")}`,
  },
};
const toastStyles = {
  style: {
    borderRadius: "10px",
    background: "#fff",
    color: "#000",
  },
  errors: {},
};
const baseUrl = myConstList.baseUrl;
const callBackBaseUrl = myConstList.callBackBaseUrl;

class Contest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      id: "",
      logo: "",
      thumnailLogo: "",
      contestName: "",
      startDate: "",
      memberShipPayment: "",
      startTime: "",
      endDate: "",
      endTime: "",
      entryFee: "",
      virtualFund: "",
      coupneRequiredValues: true,
      isModalOpen: false,
      tstatus: "",
      winningAmount1: "",
      winningCurruncy: "cashPrize",
      winningAmountusd: 0,
      description: "",
      invalidImage: "",
      max_particepate: "",
      couponRequired: "yes",
      publish: 'yes',
      membershipAmount: "",
      membershipDuration: "",
      contestFor: "",
      // heading:"",
      // about:"",
      // notes:"",
      urltemp: "",
      pair_id: [],
      message: "",
      values: [""],
      prizevalues: [""],
      winningAmountRemaining: 0,
      pairTypeTop: "all",
      top10: "",
      top50: "",
      errors: {},
    };
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    var urlTempParam = "";
    if (
      localStorage.getItem("source") !== "" &&
      localStorage.getItem("theme") !== ""
    ) {
      const urltemp =
        "?source=" +
        localStorage.getItem("source") +
        "&theme=" +
        localStorage.getItem("theme");
      this.setState({ urltemp: urltemp });
    }
    if (!this.props.auth.isAuthenticated) {
      window.location = callBackBaseUrl + "?callBack=" + window.location.origin;
    }
    // console.log("profile-data==");
    // .post(baseUrl + "api/profile-data", {},configToken)
    axios
      .post(baseUrl + "api/profile-data", {})
      .then((res) => {
        // console.log("profile-data=======",res.data.data);
        this.setState({
          bonus: res.data.data.bonus,
          winningWalletBalance: res.data.data.winningamount,
          cashWalletBalance: res.data.data.balance,
        });
      })
      .catch();
    this.setState({ scoketFlagOld: 0, scoketContestChnage: 0 });
    this.getData();
    this.getMemberShipDetails();
  }
  closeMemberShipModal = () => {
    this.setState({ isModalOpen: false });
  };

  getDataForUpdate = () => {
    axios
      .post(
        baseUrl + "api/contestOne-data",
        { id: this.props.match.params.id },
        configToken
      )
      .then((res) => {
        // console.log("momentDatamomentData", res.data.data);
        var myArray = res.data.data.levels.split(",");
        var winningPrize = res.data.data.winningPrize.split(",");

        const momentEndDate = moment
          .utc(res.data.data.endDate)
          .format("DD/MM/YYYY,HH:mm");
        const momentStartDate = moment
          .utc(res.data.data.startDate)
          .format("DD/MM/YYYY,HH:mm");
        // console.log("momentEndDate==", momentEndDate);
        this.setState({
          id: res.data.data._id,
          logo: res.data.data.contestLogo,
          hiddenLogo: res.data.data.contestLogo,
          contestName: res.data.data.contestName,
          contestStatus: res.data.data.contestStatus,
          description: res.data.data.description,
          endDate: momentEndDate,
          endTime: res.data.data.endTime,
          startTime: res.data.data.startTime,
          entryFee: res.data.data.entryFee,
          levels: res.data.data.levels,
          pair_id: res.data.data.pair_id.split(","),
          startDate: momentStartDate,
          virtualFund: res.data.data.virtualFund,
          publish: res.data.data.publish,
          winningAmount1: res.data.data.winningAmount,
          winningAmountusd: res.data.data.winningAmountInUsd,
          tstatus: res.data.data.winningLevel,
          couponRequired: res.data.data.couponRequired,
          values: myArray,
          contestFor: res.data.data.contestFor,
          prizevalues: winningPrize,
          // heading: res.data.data.heading,
          // about: res.data.data.about,
          // notes:res.data.data.notes,
          max_particepate: res.data.data.max_particepate,
        });
      })
      .catch();
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.auth.user.contest_management !== undefined &&
      nextProps.auth.user.contest_management !== true
    ) {
      this.props.history.push("/dashboard");
    }
    // console.log("nextPropsnextPropsnextProps===",nextProps);
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors,
      });
    }
    if (
      nextProps.contestdata !== undefined &&
      nextProps.contestdata.contest !== undefined &&
      nextProps.contestdata.contest.data !== undefined &&
      nextProps.contestdata.contest.data.message !== undefined &&
      nextProps.contestdata.contest.data.success
    ) {
      toast.success("Contest has been created successfully", toastStyles);
      // window.location.href = "/contest"
      let dashboardUrl = this.state.urltemp !== ""
        ? "/community-contest" + this.state.urltemp
        : "/community-contest"

      setTimeout(() => {
        this.props.history.push(dashboardUrl);
      }, 2000);
    } else {
      // console.log("nextProps.contestdata.contest.data===",nextProps.contestdata.contest.data);
    }
  }

  getData() {
    axios
      .post(baseUrl + "api/pair-data-binance", configToken)
      .then((res) => {
        this.setState({ records: res.data.data });
      })
      .catch();

    axios
      .post(baseUrl + "api/get-top-pair-list", configToken)
      .then((res) => {
        this.setState({ top10: res.data.data.top10, top50: res.data.data.top50 });
      })
      .catch();
  }

  onChangeDate = (e) => {
    if (e.target.id === "endDate") {
      if (this.state.startDate === undefined || this.state.startDate === "") {
        this.setState({
          errors: {
            startDate: "Please first select start Date",
          },
          endDate: "",
        });
      } else {
        this.setState({
          endDate: e.target.value,
          errors: {
            endDate: "",
          },
        });
      }
    }
    if (e.target.id === "startDate") {
      this.setState({
        startDate: e.target.value,
        errors: {
          startDate: "",
        },
      });
    }
  }
  onChange = (e) => {
    if (e.target.id === "pairTypeTop") {
      this.setState({
        pairTypeTop: e.target.value,
        errors: {
          pairTypeTop: "",
        },
      });
    }
    if (e.target.id === "contestName") {
      this.setState({
        contestName: e.target.value,
        errors: {
          contestName: "",
        },
      });
    }
    if (e.target.id === "entryFee") {
      this.setState({
        entryFee: e.target.value,
        errors: {
          entryFee: "",
        },
      });
    }
    if (e.target.id === "max_particepate") {
      if (e.target.value > 100) {
        this.setState({
          errors: {
            max_particepate: "Maximum particpants should be 100",
          },
        });
        return false;
      } else {
        this.setState({
          max_particepate: e.target.value,
          errors: {
            max_particepate: "",
          },
        });
      }
    }
    if (e.target.id === "virtualFund") {
      this.setState({
        virtualFund: e.target.value,
        errors: {
          virtualFund: "",
        },
      });
    }
    if (e.target.id === "publish") {
      this.setState({
        publish: e.target.value,
        errors: {
          publish: "",
        },
      });
    }
    if (e.target.id === "startTime") {
      this.setState({
        startTime: e.target.value,
        errors: {
          startTime: "",
        },
      });
    }
    if (e.target.id === "winningAmount") {
      let winningAmountValue = e.target.value;
      if (winningAmountValue.length <= 8) {
        this.setState({
          winningAmount1: e.target.value,
          winningAmountRemaining: e.target.value,
          errors: {
            winningAmount1: "",
          },
        });
      }
      else {
        this.setState({
          errors: {
            winningAmount: "Max length should be 8 digit",
          },
        });
      }
    }
    if (e.target.id === "winningAmountusd") {
      this.setState({
        winningAmountusd: e.target.value,
        errors: {
          winningAmountusd: "",
        },
      });
    }
    if (e.target.id === "winningCurruncy") {
      this.setState({
        winningCurruncy: e.target.value,
        errors: {
          winningCurruncy: "",
        },
      });
    }
    if (e.target.id === "tstatus") {
      if (this.state.max_particepate < e.target.value) {
        this.setState({
          tstatus: "",
          errors: {
            winningLevel: "Winning level should not allow more than the number of entered participants.",
          },
        });
      } else {
        this.setState({ values: "" });
        if (e.target.value.length > 0) {
          for (var i = 0; i < e.target.value; i++) {
            this.addClick();
          }
        } else {
          this.setState({ values: [""] });
        }
        this.setState({
          tstatus: e.target.value,
          errors: {
            tstatus: "",
          },
        });
      }
    }
    if (e.target.id === "couponRequired") {
      if (e.target.value === "yes") {
        this.setState({ coupneRequiredValues: true });
      } else {
        this.setState({ coupneRequiredValues: false });
      }
      this.setState({
        couponRequired: e.target.value,
        errors: {
          couponRequired: "",
        },
      });
    }

    if (e.target.id === "coupneCode") {

      if (e.target.value.length === 8) {
        this.setState({
          coupneCode: e.target.value,
          errors: {
            coupneCode: "",
          },
        });
      } else {
        this.setState({
          errors: {
            coupneCode: "Please enter 8 character with combination of alpha numeric",
          },
        });
      }
    }

    if (e.target.id === "coupanQuantity") {
      this.setState({
        coupanQuantity: e.target.value,
        errors: {
          coupanQuantity: "",
        },
      });
    }

    // if (e.target.id === 'notes') {
    //   this.setState({ notes: e.target.value,
    //     errors: {
    //       notes:''
    //     } });

    // }
    // if (e.target.id === 'about') {
    //   this.setState({ about: e.target.value,
    //     errors: {
    //       notes:''
    //     } });

    // }
    // if (e.target.id === 'heading') {
    //   this.setState({ heading: e.target.value,
    //     errors: {
    //       heading:''
    //     } });

    // }
    if (e.target.name === "contestLogo") {
      var contestLogo = e.target.files[0];
      var fileSize = e.target.files[0].size;
      if (fileSize > 10000000) {
        this.setState({
          invalidImage: "Maximum 10 MB Image allowed.",
          firstSubmitIsDisabled: true,
          userUploadImage: false,
        });
        return false;
      }
      if (!contestLogo.name.match(/\.(jpg|jpeg|png|gif)$/)) {
        this.setState({
          invalidImage: "Please select valid Front image jpeg,png,gif.",
          firstSubmitIsDisabled: true,
          userUploadImage: false,
        });
        return false;
      }
      this.setState({
        logo: contestLogo,
        thumnailLogo: URL.createObjectURL(e.target.files[0]),
        errors: {
          logo: "",
        },
      });
    }
    this.setState({ [e.target.id]: e.target.value });
  };
  createUI() {
    return this.state.values.map((el, i) => (
      <div key={i} className="row mt-2 mb-4">
        <div className="col-md-3">
          <label htmlFor="entryFee">Level {i + 1} </label>
        </div>
        <div className="col-md-9">
          <div className="row">
            {this.state.winningCurruncy === 'cashPrize' &&
              <div className="col-md-6 mb-2">
                <input
                  type="number"
                  className="form-control"
                  id={"l" + (i + 1)}
                  value={el || ""}
                  onChange={this.handleChange.bind(this, i)}
                />
                <input
                  type="hidden"
                  className="form-control"
                  id={"p" + (i + 1)}
                  value="dummy"
                  onChange={this.handleChange1.bind(this, i)}
                />
              </div>
            }
            {this.state.winningCurruncy === 'discountCoupon' &&
              <div className="col-md-6">
                <input
                  type="hidden"
                  className="form-control"
                  id={"l" + (i + 1)}
                  value="1"
                  onChange={this.handleChange.bind(this, i)}
                />
                <input
                  type="text"
                  className="form-control"
                  id={"p" + (i + 1)}
                  value={this.state.prizevalues[i] || ""}
                  onChange={this.handleChange1.bind(this, i)}
                />
              </div>
            }
          </div>
        </div>
      </div>
    ));
  }
  top10() {
    var TempArr = this.state.top10;
    var pairID = TempArr.toString().split(",");
    if (this.state.records.length > 0) {
      return this.state.records.map((el, i) => (
        el.id == pairID[i] ?
          <div key={i} className="row mt-2">
            <div className="col-5">
              <label htmlFor="entryFee">{el.name}/</label>
              <label htmlFor="entryFee">{el.box2}</label>
            </div>
          </div> : ""
      ))
    }
  }
  top50() {
    var TempArr = this.state.top50;
    var pairID = TempArr.toString().split(",");
    if (this.state.records.length > 0) {
      return this.state.records.map((el, i) => (
        el.id == pairID[i] ?
          <div key={i} className="row mt-2">
            <div className="col-5">
              <label htmlFor="entryFee">{el.name}/</label>
              <label htmlFor="entryFee">{el.box2}</label>
            </div>
          </div> : ""
      ))
    }
  }
  createPairUI() {
    var TempArr = this.state.pair_id;
    var pairID = TempArr.toString().split(",");
    if (this.state.records.length > 0) {
      return this.state.records.map((el, i) => (
        <div key={i} className="row mt-2">
          <div className="col-5">
            <label htmlFor="entryFee">{el.name}/</label>
            <label htmlFor="entryFee">{el.box2}</label>
          </div>
          <div className="col-7">
            <input
              type="checkbox"
              id={"p" + (i + 1)}
              value={el.id}
              onChange={this.handleChangePair.bind(this, i)}
              checked={pairID.indexOf(el.id.toString()) > -1 ? true : false}
            />
            {/* <input type="checkbox" id={"p" + (i + 1)} value={el.id} onChange={this.handleChangePair.bind(this, i)} checked={pairID.indexOf(el.id) > -1 ? true : false} /> */}
            {/* <input type="checkbox" id={"p" + (i + 1)} value={el.id} onChange={this.handleChangePair.bind(this, i)} /> */}
          </div>
        </div>
      ));
    }
  }

  addClick() {
    this.setState((prevState) => ({ values: [...prevState.values, ""] }));
  }

  handleChange(i, event) {
    let values = [...this.state.values];
    console.log("values[i-1]=", values[i - 1], values[i]);
    let tempwinningAmount = this.state.winningAmount1;
    values[i] = event.target.value;
    // if(values[0] && values[0] !=""){
    //   if(values[i-1]<values[i]){
    //     alert("wrong");
    //   }
    // }
    let sum = 0;
    let levelParticipate = 0;
    for (let num of values) {
      if (num) {
        levelParticipate += 1;
        sum += parseFloat(num);
      }
    }
    if (sum > this.state.winningAmount) {
      alert("winning amount low");
    } else if (levelParticipate > this.state.max_particepate) {
      alert("Winning level should be not greather then maximum paricipents");
    } else {
      tempwinningAmount = tempwinningAmount - sum;
      this.setState({ winningAmountRemaining: tempwinningAmount });
      console.log("valuesvalues=", values, i);
      this.setState({
        values,
        errors: {
          levels: "",
        },
      });
    }
  }
  handleChange1(i, event) {
    let prizevalues = [...this.state.prizevalues];
    prizevalues[i] = event.target.value;
    let sum = 0;
    let levelParticipate = 0;
    for (let num of prizevalues) {
      if (num) {
        levelParticipate += 1;
        sum += parseFloat(num);
      }
    }
    if (sum > this.state.winningAmount) {
      alert("winning amount low");
    } else if (levelParticipate > this.state.max_particepate) {
      alert("Winning level should be not greather then maximum paricipents");
    } else {
      this.setState({
        prizevalues,
        errors: {
          levels: "",
        },
      });
    }
  }
  handleChangePair(i, event) {
    var checked = event.target.checked;
    var getCheckBoxVal = event.target.value;
    if (checked === false) {
      var index = this.state.pair_id.indexOf(getCheckBoxVal);
      if (index !== -1) {
        this.state.pair_id.splice(index, 1);
      }
    } else {
      this.state.pair_id.push(getCheckBoxVal);
    }
    this.setState({ done: true });
  }
  handleCommentChange = (event, editor) => {
    var data = editor.getData();
    if (data) {
      this.setState({
        description: data,
        errors: {
          description: "",
        },
      });
    }
  };
  getMemberShipDetails = () => {
    axios
      .post(baseUrl + "api/get-membership-details", {}, configToken)
      .then((res) => {
        var resp = res.data;
        if (resp.status === false) {
          // this.setState({ isModalOpen: true });
          this.setState({ isModalOpen: false });
        }
      });
    axios.post(baseUrl + "api/membership-data", {}, configToken).then((res) => {
      var resp = res.data;
      this.setState({
        membershipDuration: resp.data[0].plan_duration,
        membershipAmount: resp.data[0].plan_amount,
      });
    });
  };

  onContestAdd = (e) => {
    e.preventDefault();
    var winningLevel = this.state.tstatus;
    if (this.state.tstatus === "" || this.state.tstatus === undefined) {
      winningLevel = "1";
    }

    // if (this.state.coupanQuantity !=="" ){
    //   if(this.state.max_particepate == this.state.coupanQuantity) {
    //     this.setState({
    //       errors: {
    //         max_particepate: "Maximum Participants should be equal to coupon quantity",
    //       },
    //     });
    //     return false;
    //   }
    // }

    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    var pairIdArr = this.state.pair_id;
    // if (Array.isArray(pairIdArr) === false) {
    //   pairIdArr = pairIdArr.split(",");
    // }
    let filtered = pairIdArr.filter(function (e) {
      return e === 0 ? "0" : e;
    });
    if (this.state.pairTypeTop == "top10") {
      filtered = this.state.top10
    }
    if (this.state.pairTypeTop == "top50") {
      filtered = this.state.top50
    }
    let couponCodeCheck = this.state.coupneCode;
    const regex = new RegExp(/^(?=.*[a-zA-Z])(?=.*[0-9])[A-Za-z0-9]+$/);
    if (regex.test(couponCodeCheck) && couponCodeCheck.length == 8) {
      this.setState({
        errors: {
          coupneCode: "",
        },
      });
    } else {
      this.setState({
        errors: {
          coupneCode: "Please enter 8 character with combination of alpha numeric",
        },
      });
      return false;
    }
    // console.log("regex.test(e.target.value)", regex.test(couponCodeCheck), couponCodeCheck);
    if(localStorage.getItem("source") ==='mobile'){
      var newData = {"hiddenLogo": this.state.hiddenLogo,
      "logo": this.state.logo,
      "contestName": this.state.contestName,
      "startTime": this.state.startTime,
      "startDate": this.state.startDate,
      "endDate": this.state.endDate,
      "endTime": this.state.endTime,
      "entryFee": this.state.entryFee,
      "virtualFund": this.state.virtualFund,
      "publish": this.state.publish,
      "winningLevel": winningLevel,
      "winningAmount": this.state.winningAmount,
      "winningAmountusd": this.state.winningAmountusd,
      "description": this.state.description,
      "pair_id": filtered,
      "levels": this.state.values,
      "max_particepate": this.state.max_particepate,
      "couponRequired": this.state.couponRequired,
      "prizevalues": this.state.prizevalues,
      "contestFor": 'all',
      "publishType": "USER",
      "pairTypeTop": this.state.pairTypeTop,
      "contestType":"trading",
    };

      if (this.state.couponRequired === "yes") {
        newData.coupneCode=this.state.coupneCode;
        newData.coupanQuantity=this.state.coupanQuantity;
      }
      console.log("add-contest-mobileadd-contest-mobile===",newData);
      axios
      .post(baseUrl + "api/add-contest-mobile", newData, configToken)
      .then(res => {
        if(res.data.success){
          toast.success(res.data.message, toastStyles);
        }else{
          toast.error(res.data.message, toastStyles);
        }
        // setTimeout(() => {
        //   window.location.href = "/contest-add"+this.state.urltemp;
        // }, 1500);
        // this.setState({ cashWalletRecords: res.data.data })
      })
      .catch();
    }else{
      const formData = new FormData();
      formData.append("hiddenLogo", this.state.hiddenLogo);
      formData.append("logo", this.state.logo);
      formData.append("contestName", this.state.contestName);
      formData.append("startTime", this.state.startTime);
      formData.append("startDate", this.state.startDate);
      formData.append("endDate", this.state.endDate);
      formData.append("endTime", this.state.endTime);
      formData.append("entryFee", this.state.entryFee);
      formData.append("virtualFund", this.state.virtualFund);
      formData.append("publish", this.state.publish);
      formData.append("winningLevel", winningLevel);
      formData.append("winningAmount", this.state.winningAmount);
      formData.append("winningAmountusd", this.state.winningAmountusd);
      formData.append("description", this.state.description);
      formData.append("pair_id", filtered);
      formData.append("levels", this.state.values);
      formData.append("max_particepate", this.state.max_particepate);
      formData.append("couponRequired", this.state.couponRequired);
      formData.append("prizevalues", this.state.prizevalues);
      formData.append("contestFor", 'all');
      formData.append("publishType", "USER");
      formData.append("pairTypeTop", this.state.pairTypeTop);
      formData.append("contestType", 'trading');
      if (this.state.couponRequired === "yes") {
        formData.append("coupneCode", this.state.coupneCode);
        formData.append("coupanQuantity", this.state.coupanQuantity);
      }
      // formData.append('heading', this.state.heading);
      // formData.append('about', this.state.about);
      // formData.append('notes', this.state.notes);
      //console.log(filtered);
      // console.log("formdata-add=", formData);
      this.props.addCommunityContest(formData, config);
    }
    
  };

  nextButtonClick = () => {
    $(".nav-item > .active").parent().next("li").find("a").trigger("click");

  };

  prevButtonClick = () => {
    $(".nav-item > .active").parent().prev("li").find("a").trigger("click");
  };

  purchaseMemberShip = (e) => {
    e.preventDefault();
    let data = {
      duration: this.state.membershipDuration,
      amount: this.state.memberShipPayment,
    };
    axios.post(baseUrl + "api/add-plan", data, configToken).then((res) => {
      var resp = res.data;
      if (resp.success === true) {
        this.setState({ isModalOpen: false });
      }
    });
  };

  removeImage = (e) => {
    e.preventDefault();
    this.setState({ thumnailLogo: "", contestLogo: "", contestLogo: "", logo: "" });
  }
  handleChangeMember = (e) => {
    let { name, value } = e.target;
    this.setState({ memberShipPayment: value });
  };

  render() {
    const { errors } = this.state;
    return (
      <>
        <Navbar urlPath={true} symbol={false} />
        <Sidebar />
        <div className="in_page">
          <div className="container">
            <div className=" row">
              <br />
              <div className="col-md-2"></div>
              <div className="col-md-8">
                <div className=" padding_d tab_borm_box">
                  <ul className="nav nav_left_tab form_tab justify-content-center">
                    <li className="nav-item">
                      <a
                        className="active show"
                        data-toggle="tab"
                        href="#details"
                      >
                        <i className="la la-file-alt l_i"></i>
                        Details
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="" data-toggle="tab" href="#prizeMoney">
                        <i className="las la-hand-holding-usd l_i"></i>
                        Prize Money
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="" data-toggle="tab" href="#paid">
                        <i className="las la-user-friends l_i"></i>
                        Pair
                      </a>
                    </li>
                    <li className="nav-item">
                      <a className="" data-toggle="tab" href="#contestRule">
                        <i className="las la-file-contract l_i"></i>
                        Contest Rule
                      </a>
                    </li>
                    {/* <li className="nav-item">
                      <a className="" data-toggle="tab" href="#contestRule">
                        <i className="las la-money-bill-wave l_i"></i>
                        Payment
                      </a>
                    </li> */}
                  </ul>
                  <form noValidate onSubmit={this.onContestAdd} id="add-user">
                    <div className="white_box">
                      <div className="tab-content ">
                        <div className="tab-pane active show" id="details">
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="contestName">Contest Name</label>
                            </div>
                            <div className="col-md-9">
                              <input
                                onChange={this.onChange}
                                value={this.state.contestName}
                                error={errors.contestName}
                                id="contestName"
                                type="text"
                                className={classnames("form-control", {
                                  invalid: errors.contestName,
                                })}
                              />
                              <span className="text-danger">
                                {errors.contestName}
                              </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="contestLogo">Banner</label>
                            </div>
                            <div className="col-md-9">
                              <input
                                className="form-control"
                                onChange={this.onChange}
                                value={this.state.contestLogo}
                                id="contestLogo"
                                name="contestLogo"
                                type="file"
                              />
                              {this.state.logo === "" ? (
                                ""
                              ) : (this.state.thumnailLogo !== "" &&
                                <div className="image-close position-relative">
                                  <a href="#" className="position-absolute" onClick={this.removeImage}>X</a>
                                  <img
                                    style={{ width: "92px", height: "70px" }}
                                    src={this.state.thumnailLogo}
                                  />
                                </div>
                              )}
                              <span className="text-danger">
                                {this.state.invalidImage}
                              </span>
                              <span className="text-danger">{errors.logo}</span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="virtualFund">Unique Code Enable</label>
                            </div>
                            <div className="col-md-9">
                              <select
                                onChange={this.onChange}
                                value={this.state.couponRequired}
                                id="couponRequired"
                                error={errors.couponRequired}
                                className={classnames("form-control", {
                                  invalid: errors.couponRequired,
                                })}
                                disabled
                              >
                                <option value="">Select</option>
                                <option value="no">No</option>
                                <option value="yes">Yes</option>
                              </select>
                              <span className="text-danger">
                                {errors.couponRequired}
                              </span>
                            </div>
                          </div>
                          {this.state.coupneRequiredValues === true && <>
                            <div className="row mt-2">
                              <div className="col-md-3">
                                <label htmlFor="virtualFund">Enter your unique code</label>
                              </div>
                              <div className="col-md-9">
                                <input
                                  id="coupneCode"
                                  onChange={this.onChange}
                                  value={this.state.coupneCode}
                                  error={errors.coupneCode}
                                  maxLength={8}
                                  className={classnames("form-control", {
                                    invalid: errors.coupneCode,
                                  })}
                                />
                                <span className="text-danger">
                                  {errors.coupneCode}
                                </span>
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-3">
                                <label htmlFor="max_particepate">
                                  Maximum Participants
                                </label>
                              </div>
                              <div className="col-md-9">
                                <input
                                  onChange={this.onChange}
                                  value={this.state.max_particepate}
                                  id="max_particepate"
                                  type="text"
                                  error={errors.max_particepate}
                                  className={classnames("form-control", {
                                    invalid: errors.max_particepate,
                                  })}
                                // readOnly={this.state.couponRequired=="yes"?true:false}
                                />
                                <span className="text-danger">
                                  {errors.max_particepate}
                                </span>
                              </div>
                            </div>
                            <div className="row mt-2">
                              <div className="col-md-3">
                                <label htmlFor="virtualFund">Unique Code Quantity</label>
                              </div>
                              <div className="col-md-9">
                                <input
                                  id="coupanQuantity"
                                  onChange={this.onChange}
                                  placeholder="Coupon Quantity"
                                  type={"number"}
                                  value={this.state.coupanQuantity}
                                  error={errors.coupanQuantity}
                                  className={classnames("form-control", {
                                    invalid: errors.coupanQuantity,
                                  })}
                                />
                                <span className="text-danger">
                                  {errors.coupanQuantity}
                                </span>
                              </div>
                            </div>
                          </>}
                          {/* <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="virtualFund">Contest For</label>
                            </div>
                            <div className="col-md-9">
                              <select
                                onChange={this.onChange}
                                value={this.state.contestFor}
                                id="contestFor"
                                error={errors.contestFor}
                                className={classnames("form-control", {
                                  invalid: errors.contestFor,
                                })}
                              >
                                <option value="">Select</option>
                                <option value="india">India</option>
                                <option value="all">For All</option>
                              </select>
                              <span className="text-danger">
                                {errors.contestFor}
                              </span>
                            </div>
                          </div> */}
                          {/* <div className="row mt-2">
                                    <div className="col-md-3">
                                        <label htmlFor="entryFee">Entry Fee</label>
                                    </div>
                                    <div className="col-md-9">
                                        <input
                                        onChange={this.onChange}
                                        value={this.state.entryFee}
                                        id="entryFee"
                                        type="text"
                                        error={errors.entryFee}
                                        className={classnames("form-control", {
                                            invalid: errors.entryFee
                                        })} />
                                        <span className="text-danger">{errors.entryFee}</span>
                                    </div>
                                    </div> */}

                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="virtualFund">Virtual Fund</label>
                            </div>
                            <div className="col-md-9">
                              <div className="info-outer position-relative">
                                <input
                                  onChange={this.onChange}
                                  value={this.state.virtualFund}
                                  id="virtualFund"
                                  type="text"
                                  error={errors.virtualFund}
                                  className={classnames("form-control", {
                                    invalid: errors.virtualFund,
                                  })}
                                />

                                <div className="info-title position-absolute">
                                  <i className="fa fa-info-circle" aria-hidden="true" data-toggle="tooltip" data-placement="left"></i>
                                  <p className="position-absolute title-text">Add mock trading funds for trading purpose</p>
                                </div>
                                <span className="text-danger">
                                  {errors.virtualFund}
                                </span>
                              </div>
                            </div>
                          </div>

                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="virtualFund">Publish</label>
                            </div>
                            <div className="col-md-9">
                              <select
                                onChange={this.onChange}
                                value={this.state.publish}
                                id="publish"
                                error={errors.publish}
                                className={classnames("form-control", {
                                  invalid: errors.publish,
                                })}
                                disabled
                              >
                                <option value="">Select</option>
                                <option value="no">No</option>
                                <option value="yes">Yes</option>
                              </select>
                              <span className="text-danger">
                                {errors.virtualFund}
                              </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="startDate">Start Time</label>
                            </div>
                            <div className="col-md-9">
                              <input
                                autoComplete={""}
                                onChange={this.onChangeDate}
                                value={this.state.startDate}
                                error={errors.startDate}
                                id="startDate"
                                type="datetime-local"
                                className={classnames("form-control", {
                                  invalid: errors.startDate,
                                })}
                              />
                              <span className="text-danger">
                                {errors.startDate}
                              </span>
                            </div>
                            {/* <div className="col-md-2">
                                        <input
                                        autoComplete={''}
                                        onChange={this.onChange}
                                        value={this.state.startTime}
                                        error={errors.startTime}
                                        id="startTime"
                                        type="time"
                                        className={classnames("form-control", {
                                            invalid: errors.startTime
                                        })}
                                        />
                                        <span className="text-danger">{errors.startTime}</span>
                                    </div> */}
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="endTime">End Time</label>
                            </div>
                            <div className="col-md-9">
                              <input
                                autoComplete={""}
                                onChange={this.onChangeDate}
                                value={this.state.endDate}
                                id="endDate"
                                type="datetime-local" min={format(this.state.startDate, 'YYYY-MM-DD mm:ss')}
                                className={classnames("form-control", {
                                  invalid: errors.endDate,
                                })}
                              />
                              <span className="text-danger">
                                {errors.endDate}
                              </span>
                            </div>
                            {/* <div className="col-md-2">
                                        <input
                                        autoComplete={''}
                                        onChange={this.onChange}
                                        value={this.state.endTime}
                                        id="endTime"
                                        type="time"
                                        className={classnames("form-control", {
                                            invalid: errors.endTime
                                        })}
                                        />
                                        <span className="text-danger">{errors.endTime}</span>
                                    </div> */}
                          </div>
                          <br />
                          {/* <div class="d-flex align-items-center pt-4">
                            <div id="prev"><button class="btn previous_btn">Previous</button></div>
                            <a onClick={this.nextButtonClick} className="btn btn_man" >
                              Next </a>
                          </div> */}
                        </div>

                        <div className="tab-pane" id="prizeMoney">
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="virtualFund">Select Currency</label>
                            </div>
                            <div className="col-md-9">
                              <select
                                onChange={this.onChange}
                                value={this.state.winningCurruncy}
                                id="winningCurruncy"
                                error={errors.winningCurruncy}
                                className={classnames("form-control", {
                                  invalid: errors.winningCurruncy,
                                })}
                              >
                                <option value="">Select</option>
                                <option value="cashPrize">Cash Prize</option>
                                <option value="discountCoupon">Discount Coupon</option>
                              </select>
                              <span className="text-danger">
                                {errors.winningCurruncy}
                              </span>
                            </div>
                          </div>
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="winningAmount">
                                Winning Amount
                              </label>
                            </div>
                            <div className="col-md-9">
                              <input
                                onChange={this.onChange}
                                value={this.state.winningAmount1}
                                placeholder="0.00"
                                id="winningAmount"
                                type="number"
                                className="form-control"
                              />
                              <span className="text-danger">
                                {errors.winningAmount}
                              </span>
                            </div>
                          </div>
                          {/* <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="winningAmountusd">
                                Winning Amount In USD
                              </label>
                            </div>
                            <div className="col-md-9">
                              <input
                                onChange={this.onChange}
                                value={this.state.winningAmountusd}
                                id="winningAmountusd"
                                type="text"
                                className="form-control"
                              />
                              <span className="text-danger">
                                {errors.winningAmountusd}
                              </span>
                            </div>
                          </div> */}
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="entryFee">Winning Level</label>
                            </div>
                            <div className="col-md-7">
                              <input
                                onChange={this.onChange}
                                value={this.state.tstatus}
                                id="tstatus"
                                type="text"
                                className="form-control"
                              />
                              <span className="text-danger">
                                {errors.winningLevel}
                              </span>
                            </div>
                            <div className="col-md-2">
                              <span className="text-success">
                                {this.state.winningAmountRemaining}
                              </span>
                            </div>
                          </div>
                          {this.createUI()}
                          {/* <div className="text-right">
                            <a
                              onClick={this.prevButtonClick}
                              className="btn btn_man"
                            >
                              Previous
                            </a>
                            <a
                              onClick={this.nextButtonClick}
                              className="btn btn_man ml-2"
                            >
                              Next
                            </a>
                          </div> */}
                          {/* <br />
                          <div class="d-flex align-items-center pt-4">
                            <div id="prev"><button class="btn previous_btn">Previous</button></div>
                            <div class="ml-auto ">  <a onClick={this.nextButtonClick} className="btn btn_man" data-toggle="tab" href="#paid">
                              Next </a></div>
                          </div> */}
                        </div>

                        <div className="tab-pane" id="paid">
                          <div className="row mt-2">
                            <div className="col-md-3">
                              <label htmlFor="virtualFund">Select Pair Type</label>
                            </div>
                            <div className="col-md-9">
                              <select
                                onChange={this.onChange}
                                value={this.state.pairTypeTop}
                                id="pairTypeTop"
                                error={errors.pairTypeTop}
                                className={classnames("form-control", {
                                  invalid: errors.pairTypeTop,
                                })}
                              >
                                <option value="">Select</option>
                                <option value="all">All</option>
                                <option value="top10">Top 10</option>
                                <option value="top50">Top 50</option>
                              </select>
                              <span className="text-danger">
                                {errors.virtualFund}
                              </span>
                            </div>
                          </div>
                          {this.state.pairTypeTop === "all" &&
                            this.createPairUI()
                          }
                          {this.state.pairTypeTop === "top10" &&
                            this.top10()
                          }
                          {this.state.pairTypeTop === "top50" &&
                            this.top50()
                          }

                          <span className="text-danger">
                            {this.state.errors.pair_id}
                          </span>
                          <br />
                          {/* <div className="text-right">
                            <a
                              onClick={this.prevButtonClick}
                              className="btn btn_man"
                            >
                              Previous
                            </a>
                            <a
                              onClick={this.nextButtonClick}
                              className="btn btn_man ml-2"
                            >
                              Next
                            </a>
                          </div> */}
                        </div>
                        <div className="tab-pane " id="contestRule">
                          <div className="row mt-2">
                            {/* <div className="col-md-12">
                                        <label htmlFor="contestName">Contest Heading:-</label>
                                    </div>
                                    <div className="col-md-12">
                                    <input
                                        onChange={this.onChange}
                                        value={this.state.heading}
                                        id="heading"
                                        type="text"
                                        className="form-control"
                                        />
                                        <span className="text-danger">{errors.heading}</span>
                                        </div> */}
                            {/* <div className="col-md-12">
                                        <label htmlFor="contestName">About :-</label>
                                    </div>
                                
                                    <div className="col-md-12">
                                        <textarea
                                        value={this.state.about}
                                        id="about"
                                        onChange={this.onChange}
                                        className="form-control"
                                        ></textarea>
                                        <br />
                                        <span className="text-danger">{errors.about}</span>
                                    </div> */}
                            {/* <div className="col-md-12">
                                        <label htmlFor="contestName">Important Notes :-</label>
                                    </div>
                                
                                    <div className="col-md-12">
                                        <textarea
                                        value={this.state.notes}
                                        onChange={this.onChange}
                                        id="notes"
                                        className="form-control "
                                        data={this.state.notes} ></textarea>
                                        <br />
                                        <span className="text-danger">{errors.notes}</span>
                                    </div> */}
                            <div className="col-md-12">
                              <label htmlFor="contestName">
                                Write Contest Rule :-
                              </label>
                            </div>

                            <div className="col-md-12">
                              <CKEditor
                                editor={ClassicEditor}
                                value={this.state.description}
                                onChange={this.handleCommentChange}
                                placeholder="Enter Description"
                                className="form-control form_control_textarea"
                                data={this.state.description}
                              />
                              <br />
                              <span className="text-danger">
                                {errors.description}
                              </span>
                            </div>
                          </div>
                          <div className="form-group mb-5 mt-2 text-right">
                            {/* <a
                              onClick={this.prevButtonClick}
                              className="btn btn_man"
                            >
                              Previous
                            </a> */}

                            <button type="submit" className="btn btn_man ml-2">
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
                {/* Member Ship Modal Start */}
                <Modal
                  show={this.state.isModalOpen}
                  onHide={this.closeMemberShipModal}
                  backdrop="static"
                  className="account-popup-outer"
                  keyboard={false}
                >
                  <Modal.Header>
                    <Modal.Title> Purchase Membership</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <p className="tc mt-0 note">
                      You don't have an membership active. Please purchase
                      membership
                    </p>

                    <div className="row align-items-center">
                      <div className="col-md-6">
                        <p>Amount: {this.state.membershipAmount}</p>
                      </div>
                      <div className="col-md-6">
                        <p>Duration: {this.state.membershipDuration} Days</p>
                      </div>
                      <div className="col-md-12">
                        <input
                          className="form-control"
                          name="memberShipPayment"
                          value={this.state.memberShipPayment}
                          onChange={this.handleChangeMember}
                        />
                      </div>
                      <div className="mt-3">
                        <button
                          className="btn btn_man ml-2"
                          onClick={this.purchaseMemberShip}
                        >
                          Purchase
                        </button>
                      </div>
                    </div>
                  </Modal.Body>
                </Modal>
                {/* Member Ship Modal End */}
              </div>
            </div>
          </div>
        </div>
        <Footer />
        <Toaster position="bottom-right" reverseOrder={false} />
      </>
    );
  }
}

Contest.propTypes = {
  auth: PropTypes.object.isRequired,
  addCommunityContest: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  contestdata: state.contestdata,
  records: state.records,
  errors: state.errors,
});

export default connect(mapStateToProps, { addCommunityContest })(Contest);
